var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"theTopButton clickable",attrs:{"alt":""},on:{"click":_vm.onClickBackToTop}})
}
var staticRenderFns = []

export { render, staticRenderFns }